const PropTypes = require('prop-types');
const React = require('react');
const PriceWithChange = require('./price_with_change.jsx');

class PromoProduct extends React.Component {
  static propTypes = {
    listing: PropTypes.object.isRequired,
    originalPrice: PropTypes.object.isRequired,
    discountedPrice: PropTypes.object,
  };

  render() {
    const listing = this.props.listing;

    return (
      <a href={listing._links.web.href}>
        <div className="g-container mb-half">
          <div className="g-col-3 g-col-mobile-2">
            <img className="img-wide bd-rounded img-hoverable bordered" src={listing._links.photo.href} />
          </div>
          <div className="g-col-9 g-col-mobile-10">
            <p className="product-bundle-item-title strong color-gray">{listing.title}</p>
            <p className="product-bundle-item-price color-gray">
              <PriceWithChange price={this.props.originalPrice} discountedPrice={this.props.discountedPrice} />
            </p>
          </div>
        </div>
      </a>
    );
  }
}

module.exports = PromoProduct;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/promo_product.jsx